if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.targetDate =  new Date(this.dataset.endTime).getTime();
      if (this.targetDate === '' || isNaN(this.targetDate)) return;

      this.wrappers = {};
      this.currentValues = {};
      ['days', 'hours', 'minutes', 'seconds'].forEach(unit => {
        const element = this.querySelector(`[data-${unit}]`);
        if (element) {
          element.innerHTML = '';
          this.wrappers[unit] = element;
          this.currentValues[unit] = null;
        }
      });

      // Initialize digit wrappers
      Object.keys(this.wrappers).forEach(unit => {
        const wrapper = this.wrappers[unit];
        // Create digit wrappers for each unit
        if (unit === 'days') {
          // Support up to 999 days with 3 digits
          for (let i = 0; i < 3; i++) {
            const digitWrapper = document.createElement('div');
            digitWrapper.className = 'timer__digit-wrapper';
            wrapper.appendChild(digitWrapper);
          }
        } else {
          for (let i = 0; i < 2; i++) {
            const digitWrapper = document.createElement('div');
            digitWrapper.className = 'timer__digit-wrapper';
            wrapper.appendChild(digitWrapper);
          }
        }
      });
    }

    convertTimezone(timezone) {
      const now = new Date();
      const local_time = now.getTime();
      const local_offset = now.getTimezoneOffset() * 60000;
      const utc = local_time + local_offset;
      return new Date(utc + (3600000 * parseInt(timezone)));
    };

    animateDigit(digitWrapper, newDigit, oldDigit) {
      if (oldDigit === null || oldDigit === newDigit) {
        if (!digitWrapper.hasChildNodes()) {
          const digitElement = document.createElement('span');
          digitElement.className = 'timer__digit timer__digit--current';
          digitElement.textContent = newDigit;
          digitWrapper.appendChild(digitElement);
        }
        return;
      }
            
      // Create and animate old digit
      const oldElement = digitWrapper.querySelector('.timer__digit');
      if (oldElement) {
        oldElement.className = 'timer__digit timer__digit--old';
        setInterval(() => oldElement.remove(), 300);
      }
      
      // Create and animate new digit
      const newElement = document.createElement('span');
      newElement.className = 'timer__digit timer__digit--new';
      newElement.textContent = newDigit;
      digitWrapper.appendChild(newElement);
    }
  
    updateUnit(wrapper, newValue, oldValue) {
      const digitWrappers = wrapper.querySelectorAll('.timer__digit-wrapper');
      const newDigits = newValue.toString().padStart(2, '0').split('');
      const oldDigits = oldValue === null ? [null, null] : oldValue.toString().padStart(2, '0').split('');
      // cleanup any old digits and initialize new ones
      this.querySelectorAll('.timer__digit--old').forEach(element => element.remove());
      
      digitWrappers.forEach((digitWrapper, index) => {
        if (oldDigits[index] !== newDigits[index]) {
          this.animateDigit(digitWrapper, newDigits[index], oldDigits[index]);
        }
      });
    }
    
    updateCountdown() {
      if (this.targetDate === '' || isNaN(this.targetDate)) return;
      const timeInStoreTimezone = this.convertTimezone(this.dataset.timezone);
      const currentDate = new Date(timeInStoreTimezone);
      const timeDifference = this.targetDate - currentDate;
      
      // If we've passed the target date
      if (timeDifference <= 0) {
        Object.keys(this.wrappers).forEach(unit => {
          this.updateUnit(this.wrappers[unit], '00', this.currentValues[unit]);
          this.currentValues[unit] = '00';
        });
        clearInterval(this.timer);

        if (this.dataset.hideAfterEnd === 'true') {
          const sectionId = `shopify-section-${this.dataset.sectionId}`;
          document.getElementById(sectionId).querySelector('.js-countdown-timer-wrapper').style.display = 'none';
        } else if (this.dataset.showMessageAfterEnd === 'true') {
          this.querySelector('[data-message-after-end]').classList.remove('display--none');
        }
        return;
      }

      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
      
      const newValues = {
        days: days.toString().padStart(2, '0'),
        hours: hours.toString().padStart(2, '0'),
        minutes: minutes.toString().padStart(2, '0'),
        seconds: seconds.toString().padStart(2, '0')
      };
      
      Object.keys(newValues).forEach(unit => {
        if (this.currentValues[unit] !== newValues[unit]) {
          this.updateUnit(this.wrappers[unit], newValues[unit], this.currentValues[unit]);
          this.currentValues[unit] = newValues[unit];
        }
      });
    }

    connectedCallback() {
      // Start the countdown
      this.updateCountdown();
      this.timer = setInterval(() => this.updateCountdown(), 1000);
    }
    
    disconnectedCallback() {
      // Clean up the interval when the element is removed
      if (this.timer) {
        clearInterval(this.timer);
      }
    }
  });
}
